$(document).ready( function() {

	// Product page
	$('#ask-product-infos-top').click( function(e) {

		dataLayer.push({
			event: "ask-product-infos-top",
			event_category: "cta",
			event_label: $('h2').text() + "-" + $('html').prop("lang")
	 	});

		ym(57269581, 'reachGoal', 'ask-product-infos-top', {
			category: 'cta',
			lang: $('html').prop("lang"),
			product: $('h2').text(),
		});

	})

	$('#ask-product-infos-bottom').click( function(e) {

		dataLayer.push({
			event: "ask-product-infos-bottom",
			event_category: "cta",
			event_label: $('h2').text() + "-" + $('html').prop("lang"),
	 	});

		ym(57269581, 'reachGoal', 'ask-product-infos-bottom', {
			category: 'cta',
			lang: $('html').prop("lang"),
			product: $('h2').text(),
		});

	})


	/*
	 * Contatti
	 */
	$('a[href^="mailto:"]').click( function(e) {

		var email = $(this).prop('href').replace("mailto:", "");

		dataLayer.push({
			event: "click-mailto-link",
			event_category: "contacts",
			event_label: email + " - " + $('html').prop("lang"),
	 	});

		ym(57269581, 'reachGoal', 'click-mailto-link', {
			category: "contacts",
			lang: $('html').prop("lang"),
			email: email + " - " + $('html').prop("lang"),
		});

	});

	// Contact page events in _contact.js


	/*
	 * Documents download
	 */

	// tech sheet
	$('.dl-tech-sheet').click( function(e) {

		var filename = $(this).prop('href').split('/').pop();

		dataLayer.push({
			event: "dl-tech-sheet",
			event_category: "doc-download",
			event_label: filename + " - " + $('html').prop("lang"),
	 	});

		ym(57269581, 'reachGoal', 'dl-tech-sheet', {
			category: "doc-download",
			lang: $('html').prop("lang"),
			filename: filename
		});

	});

	// dl-manual
	$('.dl-manual').click( function(e) {

		var filename = $(this).prop('href').split('/').pop();

		dataLayer.push({
			event: "dl-manual",
			event_category: "doc-download",
			event_label: filename + " - " + $('html').prop("lang"),
	 	});

		ym(57269581, 'reachGoal', 'dl-manual', {
			category: "doc-download",
			lang: $('html').prop("lang"),
			filename: filename
		});

	});

	// dl-additional-document
	$('.dl-additional-document').click( function(e) {

		var filename = $(this).prop('href').split('/').pop();

		dataLayer.push({
			event: "dl-additional-document",
			event_category: "doc-download",
			event_label: filename + " - " + $('html').prop("lang"),
	 	});

		ym(57269581, 'reachGoal', 'dl-additional-document', {
			category: "doc-download",
			lang: $('html').prop("lang"),
			filename: filename
		});

	});

	// dl-regulations
	$('.dl-regulations').click( function(e) {

		var filename = $(this).prop('href').split('/').pop();

		dataLayer.push({
			event: "dl-regulations",
			event_category: "doc-download",
			event_label: filename + " - " + $('html').prop("lang"),
	 	});

		ym(57269581, 'reachGoal', 'dl-regulations', {
			category: "doc-download",
			lang: $('html').prop("lang"),
			filename: filename
		});

	});

});



//////////////////
// WEBPACK FOOTER
// ./assets/js/partials/_analytics.js
// module id = 5
// module chunks = 0